"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  trackInteraction: function trackInteraction() {},
  trackBeforeUnloadInteraction: function trackBeforeUnloadInteraction() {},
  trackPageView: function trackPageView() {},
  trackFilterView: function trackFilterView() {},
  trackResultClick: function trackResultClick() {}
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/context/StorefrontUsageTrackerContext.js
// module id = 135
// module chunks = 209 210 211 212